// Owner: slides-editor (plan §9.10, §3.1). The deck editor (focus layout, no rail); the screen lives in
// `-DeckRoute.tsx` and loads with the route, not with the app's first paint (plan §10.2). `?slide=` opens a
// slide; `?ai=generate` opens the deck AI's "Generate slides" (slides-ai §9.29); `/decks/new?ai=generate`
// creates a presentation first (⌘K "New presentation with AI").
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DeckRoute } from './-DeckRoute';

const Search = z.object({
  slide: z.string().min(1).max(80).optional().catch(undefined),
  ai: z.enum(['generate']).optional().catch(undefined),
});

export const Route = createFileRoute('/_focus/decks/$deckId')({
  validateSearch: Search,
  component: DeckRoute,
});
